import React from 'react';
import { Typography } from 'antd';

const { Title } = Typography;

interface Props {
  title: string;
}

const PlaceholderPage: React.FC<Props> = ({ title }) => {
  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>{title}</Title>
      <p>این صفحه هنوز ساخته نشده است.</p>
    </div>
  );
};

export default PlaceholderPage;
